<mat-form-field style="width: 100%;">
  <mat-label class="select-placeholder-container">
    <div style="display: flex; flex-direction: row; gap: 2px; align-items: center; justify-content: flex-start;">
      <mat-icon svgIcon="group"></mat-icon>
      <span>{{ 'groupingColumn' | translate }}</span>
    </div>
  </mat-label>
  <mat-select [(value)]="selectedGroupingColumn">
    <mat-option [value]="null">-- {{ 'doNotGroup' | translate }} --</mat-option>
    <mat-option *ngFor="let column of availableColumns" [value]="column.name">
      {{ column.title | translate | capitalizeFirst }}
    </mat-option>
  </mat-select>
</mat-form-field>